module.exports = __webpack_public_path__ + "img/platform-logo-netafim.1590ab2a.png";